import { useAccount, useEnv } from '@src/contexts';
import Box from '@sendsprint/ui-react/dist/components/Box';
import Text from '@sendsprint/ui-react/dist/components/Text';
import { Switch } from '@headlessui/react';
import cs from 'classnames';
import React from 'react';

const SwitchEnvironment = () => {
  const { IS_PROD, STAGING_URL, PROD_URL } = useEnv();
  const { isRemittanceBusiness } = useAccount();

  const urlSuffix = '/sender/setup-guide';

  if (!isRemittanceBusiness) return <></>;

  const handleChange = (checked: boolean) => {
    if (checked) {
      window.location.href = `${PROD_URL}${urlSuffix}`;
    } else {
      window.location.href = `${STAGING_URL}${urlSuffix}`;
    }
  };

  return (
    <Box className="ss-flex ss-items-center ss-gap-2">
      <Text>Switch to {IS_PROD ? 'test' : 'live'}</Text>
      <Switch
        checked={IS_PROD}
        onChange={handleChange}
        className={cs(
          'ss-group ss-relative ss-flex ss-h-7 ss-w-14 ss-cursor-pointer ss-rounded-full ss-p-1 ss-transition-colors ss-duration-200 ss-ease-in-out focus:ss-outline-none data-[focus]:ss-outline-1 data-[focus]:ss-outline-white',
          {
            'ss-bg-success-600': IS_PROD,
            'ss-bg-black/10': !IS_PROD
          }
        )}>
        <span
          aria-hidden="true"
          className={cs(
            'ss-pointer-events-none ss-inline-block ss-size-5 ss-rounded-full ss-transform ss-bg-white ss-ring-0 ss-shadow-lg ss-transition ss-duration-200 ss-ease-in-out',
            {
              'ss-translate-x-7': IS_PROD,
              'ss-translate-x-0': !IS_PROD
            }
          )}
        />
      </Switch>
    </Box>
  );
};

export default SwitchEnvironment;
